import Vue from 'vue'
import Vuex from 'vuex'
import plugins from './plugins'
import state from './state'
import actions from './actions'
import mutations from './mutations'

Vue.use(Vuex)

export default new Vuex.Store({
  plugins,
  state,
  actions,
  mutations
})
